import { useNavigate, useLocation } from 'react-router-dom';
import { footerLinks } from '../../../mocks/landingData';
import { socialLinks } from '../../../mocks/socialLinks';

export default function FooterSection() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLinkClick = (href: string, e: React.MouseEvent<HTMLAnchorElement>) => {
    if (/^https?:\/\//.test(href)) return;

    e.preventDefault();

    if (href.startsWith('#')) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    if (href.startsWith('/#')) {
      const [path, hash] = href.split('#');
      if (location.pathname === path || location.pathname === '/') {
        const el = document.querySelector(`#${hash}`);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      } else {
        navigate(href);
        setTimeout(() => {
          const el = document.querySelector(`#${hash}`);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
      return;
    }

    navigate(href);
  };

  return (
    <footer className="relative py-16 bg-midnight border-t border-royal-navy/30">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <img
                  src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/ce990b2a1f8c24014284f37f11ea468a.jpeg"
                  alt="TNT Coach AI"
                  className="h-8 w-auto object-contain"
                />
              </div>
              <p className="text-silver-grey text-sm leading-relaxed mb-4">
                Top Notch Transformation Coaching.
              </p>
              <p className="text-silver-grey text-sm leading-relaxed">
                TNT Coach AI gives you instant coaching guidance whenever you feel stuck, overwhelmed, or unsure what to do next — helping you find clarity, build confidence, and take action.
              </p>
            </div>

            {footerLinks.map((section, index) => (
              <div key={index}>
                <h4 className="text-silver-grey text-sm font-semibold uppercase tracking-wider mb-4">
                  {section.title}
                </h4>
                <ul className="space-y-3">
                  {section.links.map((link, lIndex) => (
                    <li key={lIndex}>
                      <a
                        href={link.href}
                        onClick={(e) => handleLinkClick(link.href, e)}
                        {...(/^https?:\/\//.test(link.href)
                          ? { target: '_blank', rel: 'noopener noreferrer' }
                          : {})}
                        className="text-silver-grey hover:text-champagne-gold transition-colors duration-300 text-sm cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-royal-navy/30 pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-silver-grey text-sm">
                &copy; 2026 TNT Coach AI. All rights reserved.
              </p>
              <div className="flex items-center gap-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.platform}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${social.platform} - Top Notch Technologies`}
                    title={social.platform}
                    className="w-8 h-8 rounded-full bg-royal-navy/30 flex items-center justify-center text-silver-grey hover:text-champagne-gold hover:bg-royal-navy/50 transition-all duration-300 cursor-pointer"
                  >
                    <i className={`${social.icon} text-sm`} />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}